import PrivacyForm from './PrivacyForm.component';

export default PrivacyForm;